import { type FC, useState } from "react";
import { useShopfrontDispatch } from "../../../_Bootstrap/hooks";
import { hideDialog } from "../../../Actions/Dialogs/DialogActions";
import { startLoading, stopLoading } from "../../../Actions/General/LayoutActions";
import Request from "../../../Utilities/Platform/Request";
import Button from "../../Buttons/Button";
import PopupManager from "../../Popups/PopupManager";
import { type MediaPathType, type MediaSelectedType } from "./MediaUtilities";

interface Props {
    path: Array<MediaPathType>;
    item: MediaSelectedType;
    onRename: (name: string) => void;
}

export const RenameItem: FC<Props> = ({
    path,
    item,
    onRename,
}) => {
    const [ name, setName ] = useState(item.name);

    const dispatch = useShopfrontDispatch();

    const onRenameClick = (): Promise<void> => {
        if(path?.[0]?.id !== "home") {
            return Promise.reject("Permission Denied");
        }

        dispatch(hideDialog());
        dispatch(startLoading());

        return Request.put(`/media/${item.id}/${item.type}`, {
            name,
        })
            .then(async (results: any) => {
                if(results.error) {
                    PopupManager.error("Failed to rename the " + item.type);

                    return;
                }

                onRename(name);

                PopupManager.success("Successfully renamed the " + item.type);
            })
            .catch(err => {
                console.error("There was an issue trying to rename the", item.type, err);
                PopupManager.error("There was an issue trying to rename the " + item.type);
            })
            .then(() => {
                dispatch(stopLoading());
            });
    };

    return (
        <div className="directory-name">
            <p>What should the {item.type}, {item.name}, be renamed to?</p>
            <input
                type="text"
                name="name"
                value={name}
                onChange={e => {
                    setName(e.currentTarget.value);
                }}
                autoFocus
            />
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => {
                        dispatch(hideDialog());
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "button-add" ]}
                    onClick={onRenameClick}
                >
                    Rename
                </Button>
            </div>
        </div>
    );
};
